import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { SingleMultipleChoiceAnswerValue } from '../answer-value';
import { Answer } from './answer';
import { SubmissionScore } from '../submission-score';
export var SingleChoiceAnswer = /*#__PURE__*/function (_Answer) {
  _inherits(SingleChoiceAnswer, _Answer);

  var _super = _createSuper(SingleChoiceAnswer);

  function SingleChoiceAnswer() {
    _classCallCheck(this, SingleChoiceAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(SingleChoiceAnswer, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "updateValue",
    value: function updateValue(newValue) {
      this.props.value = newValue;
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return !this.value;
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(question) {
      var _this = this;

      return question.correctAnswers.some(function (c) {
        var _this$value;

        return c.answerId === ((_this$value = _this.value) === null || _this$value === void 0 ? void 0 : _this$value.answerId);
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var dataOrError = this.createBaseProps(props);

      if (dataOrError.isFailure) {
        return Result.fail(dataOrError.error);
      }

      var baseProps = dataOrError.getValue();
      var collection = [{
        argument: props.value,
        argumentName: 'Value'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      props = _objectSpread(_objectSpread({}, baseProps), props);
      return Result.ok(new SingleChoiceAnswer(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var basePropsOrError = this.createBaseProps(data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var value = data.value;
        var answerValueProps;

        if (value) {
          answerValueProps = SingleMultipleChoiceAnswerValue.create({
            answerId: value.answerId || value.props.answerId
          }).getValue();
        }

        var props = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          value: answerValueProps,
          score: data !== null && data !== void 0 && data.score || data.score === 0 ? SubmissionScore.create(data.score).getValue() : null
        });

        return Result.ok(new SingleChoiceAnswer(props, new UniqueEntityID(props.id)));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SingleChoiceAnswer;
}(Answer);